import "./Divider.css";

const SHAPES = {
  wave:
    "M 0 60 C 240 20, 480 100, 720 60 C 960 20, 1200 100, 1440 60 L 1440 130 L 0 130 Z",
  "wave-alt":
    "M 0 70 C 180 120, 540 20, 720 70 C 900 120, 1260 20, 1440 70 L 1440 130 L 0 130 Z",
  curve:
    "M 0 70 Q 360 10, 720 70 T 1440 70 L 1440 130 L 0 130 Z",
};

const DURATIONS = {
  wave: 40,
  "wave-alt": 52,
  curve: 34,
};

export default function Divider({ from, to, flip = false, variant = "wave" }) {
  const d = SHAPES[variant] || SHAPES.wave;
  const duration = DURATIONS[variant] || 40;

  return (
    <div
      className={`divider divider--${variant} ${flip ? "divider--flip" : ""}`}
      style={{ background: from }}
      aria-hidden="true"
    >
      <svg
        className="divider__svg"
        viewBox="0 0 1440 128"
        preserveAspectRatio="none"
        shapeRendering="geometricPrecision"
      >
        <g
          className="divider__flow"
          style={{ animationDuration: `${duration}s` }}
        >
          <path d={d} fill={to} />
          <path d={d} fill={to} transform="translate(1440 0)" />
        </g>
      </svg>
    </div>
  );
}
